// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"vt","firstSessionModal_header":"wt","firstSessionModal_title":"xt","firstSessionModal_header_tex":"yt","firstSessionModal_video":"zt","firstSessionModal_videoContent":"At","firstSessionModal_FAQ":"Bt","firstSessionModal_FAQMargin":"Ct","firstSessionModal_FAQTitle":"Et","firstSessionModal_buttonContainer":"Ft","firstSessionModal_buttonText":"Gt","firstSessionModal_SMSBtn_mob":"Ht"};
    if(module.hot) {
      // 1713969925886
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  